import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import dayjs from "dayjs"
import AdminTable from "../Administrator/Helpers/AdminTable"
import { getClientLeadedTrainings } from "src/store/Slices/ClientsSlice"
import AssignLeadedTrainerModal from "./Modals/AssignLeadedTrainerModal"

const FALLBACK_COLUMNS = {
  data: {
    value: {
      columns: [
        { title: "Название", dataIndex: "name" },
        { title: "Клуб", dataIndex: "clubName" },
        { title: "Дней", dataIndex: "dayCount" },
        { title: "Окончание", dataIndex: "endDate" },
        { title: "Персональные", dataIndex: "personalTrainings" },
        { title: "Абонемент", dataIndex: "giveAbonement" },
        { title: "Тренер", dataIndex: "trainerName" },
        { title: "Цена", dataIndex: "purchasePrice" },
      ],
    },
  },
}

const ClientsLeadedTrainings = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  isActive,
}) => {
  const dispatch = useDispatch()
  const [trainingInfo, setTrainingInfo] = useState()
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false)
  const [tableFilters, setTableFilters] = useState({})

  const list = useSelector((state) => state.ClientsSlice.clientLeadedTrainings)
  const loading = useSelector(
    (state) => state.ClientsSlice.clientLeadedTrainingsLoading,
  )

  const items = [
    {
      key: "assign",
      label: "Назначить / снять тренера",
      onClick: () => setIsAssignModalOpen(true),
    },
  ]

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (!keys || !values) return formattedItems
    keys.forEach((key, index) => {
      if (values[index] != undefined && values[index][0] != undefined) {
        if (key === "club" || key === "clubName" || key === "clubId") {
          formattedItems.clubId = values[index][0]
        } else {
          formattedItems[key] = values[index][0]
        }
      }
    })
    return formattedItems
  }

  const load = (nextPage, nextPageSize, filters) => {
    if (!clientInfo?.id) return
    const params = {
      clientId: clientInfo.id,
      count: nextPageSize,
      offset: nextPageSize * (nextPage - 1),
      ...filters,
    }
    if (isActive === true || isActive === false) {
      params.isActive = isActive
    }
    dispatch(getClientLeadedTrainings(params))
  }

  useEffect(() => {
    load(page, pageSize, tableFilters)
  }, [clientInfo?.id, page, pageSize, isActive, tableFilters])

  const handleTableChange = (pagination, filters, sorter) => {
    const nextFilters = {
      ...searchItemsMap(Object.keys(filters), Object.values(filters)),
      orderBy: sorter?.column?.dataIndex,
      isDesc: sorter.order
        ? sorter.order === "ascend"
          ? true
          : false
        : undefined,
    }
    setTableFilters(nextFilters)
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  return (
    <>
      <AssignLeadedTrainerModal
        visible={isAssignModalOpen}
        setVisible={setIsAssignModalOpen}
        trainingInfo={trainingInfo}
        onSaved={() => load(page, pageSize, tableFilters)}
      />
      <AdminTable
        scroll={{ x: 0, y: 200 }}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onChange={handleTableChange}
        loading={loading}
        onClickRowOne={setTrainingInfo}
        columns={
          list?.data?.value?.columns?.length ? list : FALLBACK_COLUMNS
        }
        rows={list?.data?.value?.rows?.map((row) => ({
          ...row,
          endDate: row.endDate
            ? dayjs(row.endDate).format("DD.MM.YYYY")
            : row.endDate,
          giveAbonement: row.giveAbonement ? "Да" : "Нет",
        }))}
        total={list?.data?.value?.totalCount}
        title={title}
        items={items}
      />
    </>
  )
}

export default ClientsLeadedTrainings
